import axios from "axios";
import { getCookie } from "../../getcookie.js";

const apiUrl = process.env.REACT_APP_API_URL;

const getHeader = () => ({
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*",
  Authorization: getCookie("mawalog"),
});

export const getNfcList = async (params) => {
  try {
    const response = await axios.get(apiUrl + "nfc_master", {
      headers: getHeader(),
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching NFC list:", err);
    return err.response;
  }
};

export const updateNfcStatus = async (data) => {
  try {
    const response = await axios.put(`${apiUrl}/nfc_master/status_update/${data.id}`, data, {
      headers: getHeader(),
    });
    return response;
  } catch (err) {
    console.error("Error updating NFC status:", err);
    return err.response;
  }
};

export const getNfcDetails = async (id) => {
  try {
    const response = await axios.get(apiUrl + `nfc_master/${id}`, {
      headers: getHeader(),
    });
    return response;
  } catch (err) {
    console.error("Error fetching NFC details:", err);
    return err.response;
  }
};

export const deleteNfc = async (id) => {
  try {
    const response = await axios.delete(apiUrl + `nfc_master?id=${id}`, {
      headers: getHeader(),
    });
    return response;
  } catch (err) {
    console.error("Error deleting NFC:", err);
    return err.response;
  }
};

export const getNfcHistory = async (id, params) => {
  try {
    const response = await axios.get(apiUrl + `nfc_master/history/${id}`, {
      headers: getHeader(),
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching NFC history:", err);
    return err.response;
  }
};

export const getNfcChartData = async (id, params) => {
  try {
    const response = await axios.get(apiUrl + `nfc_master/chart/${id}`, {
      headers: getHeader(),
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching NFC chart data:", err);
    return err.response;
  }
};
